export default "__VITE_ASSET__DPFoWXST__"